import { Node } from 'tiptap'

const downloadIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAxNiAxNiI+CiAgPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CiAgICA8cGF0aCBmaWxsPSIjMDA3NzhGIiBkPSJNNCA4bDQgNCA0LTRIOVYwSDd2OEg0em0tNCA4aDE2di0ySDB2MnoiIC8+CiAgPC9nPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwMCI+CiAgICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMTZ2MTZIMHoiIC8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KPC9zdmc+Cg=='

const getFileType = (s) => {
  const [ext] = s.split('.').reverse()
  return `.${ext}`
}

export default class File extends Node {
  get name() {
    return 'file'
  }

  get schema() {
    return {
      inline: true,
      attrs: {
        src: {},
        text: {
          default: null,
        },
      },
      group: 'inline',
      draggable: true,
      parseDOM: [
        {
          tag: 'div[src]',
          getAttrs: (dom) => ({
            src: dom.getAttribute('src'),
            text: dom.getAttribute('text'),
          }),
        },
      ],
      toDOM: (node) => [
        'div',
        {class: 'article-file-download', ...node.attrs},
        [
          'a',
          {
            class: 'btn btn-outline-primary',
            target: '_blank',
            href: node.attrs.src,
          },
          ['span', {}, `Download ${getFileType(node.attrs.src)}`],
          // DownloadIcon,
          ['img', {src: downloadIcon}]
        ],
      ],
    }
  }

  commands({type}) {
    return (attrs) => (state, dispatch) => {
      const {selection} = state
      const position = selection.$cursor
        ? selection.$cursor.pos
        : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }
}
